const footerCols = [
  { title: '翻料入口', items: ['私藏存货', '干货家底', '热门爆料', '往期宝库'] },
  { title: '查找方式', items: ['分区索引', '专题合集', '常翻热榜', '新入库'] },
  { title: '了解更多', items: ['找料指引', '关于黑料舍', '宝库目录', '回顶部'] },
];

export default function SiteFooter() {
  const year = '2026';
  return (
    <footer className="w-full border-t border-[#dccdae] bg-[#eadfc7]">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#201b15] text-sm font-bold tracking-wide text-[#e9c579]">
                黑
              </span>
              <span className="flex flex-col leading-none">
                <span className="text-[17px] font-extrabold tracking-[0.08em] text-[#201b15]">
                  黑料舍
                </span>
                <span className="mt-1 text-[10px] font-medium tracking-[0.22em] text-[#8a7a5c]">
                  私藏档库 · Vault
                </span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-[13px] leading-relaxed text-[#6d6149]">
              把黑料舍的私藏存货与干货家底持续整理进宝库，热门爆料、老料新料都按主题与时间线
              归好位，让入舍找料更省心，翻得到、看得懂、回得来。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-6 sm:grid-cols-3 md:col-span-7">
            {footerCols.map((col) => (
              <div key={col.title}>
                <h4 className="text-[13px] font-bold tracking-wide text-[#4a4030]">
                  {col.title}
                </h4>
                <ul className="mt-3 space-y-2">
                  {col.items.map((it) => (
                    <li key={it}>
                      <a
                        href="#top"
                        className="text-[13px] text-[#8a7a5c] transition-colors hover:text-[#201b15]"
                      >
                        {it}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-[#d6c7a9] pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-[12px] text-[#8a7a5c]">
            本站内容为资料索引整理展示，仅供浏览参考，不构成任何立场或结论。
          </p>
          <p className="text-[12px] text-[#8a7a5c]">
            © {year} 黑料舍网 · 私藏存货 · 干货家底 · 宝库目录
          </p>
        </div>
      </div>
    </footer>
  );
}